import type { DocPageContent } from '../docs-content'

const page = {
  order: 22,
  slug: 'troubleshooting',
  title: '故障排除',
  description: '浏览器、工作区、媒体、WebGPU、AI、导入和导出问题。',
  category: '参考',
  sections: [
    {
      title: '浏览器与工作区',
      items: [
        '当工作区选择器不可用时，使用 Chrome 或 Edge 113+。',
        '如果 Brave 无法选择工作区文件夹，启用 Brave 文件系统访问 API。',
        '当浏览器权限过期时重新连接工作区。',
        '当权限被拒绝时，选择一个普通的可写入文件夹。',
      ],
    },
    {
      title: '媒体问题',
      items: [
        '使用"授权访问"、"定位"、"定位文件夹"或"浏览其他文件夹"重新链接缺失的媒体。',
        '仅当你打算稍后修复损坏的引用时，才使用"离线工作"。',
        '当导入失败或缺少编码器支持时，尝试其他浏览器支持的格式。',
        '当派生文件过期时，重新生成代理、缩略图、转录稿或缓存数据。',
      ],
    },
    {
      title: 'AI 与导出问题',
      items: [
        '使用支持 WebGPU 的浏览器和 GPU 配置，以获得加速和本地 AI 工作流程。',
        '当模型下载失败时，重试或清除本地 AI 模型缓存。',
        '当预检报告编码器支持问题时，选择其他导出编码器、格式、分辨率或质量。',
        '在主线程回退导出期间保持标签页焦点。',
        '当文件较大或渲染较慢时，导出较短的入/出范围。',
      ],
    },
    {
      title: 'MCP 自动化问题',
      items: [
        '如果“本地 MCP”面板显示 bridge 未连接，先检查 fastcut-mcp 是否已启动，以及端口 4174 是否被本机进程占用。',
        '如果浏览器会话未注册，确认你打开的是当前机器上的 JIAN 编辑器页面，而不是其他设备或旧标签页。',
        '如果 Codex 报找不到命令，重新安装 npm 包：npm install -g @fastcut-video/mcp-agent，并执行 fastcut-mcp --doctor。',
        '如果 MCP 能连接但项目不可用，确认已经登录、打开真实项目，并等待设置面板中显示当前项目 ID。',
      ],
    },
  ],
} satisfies DocPageContent

export default page
